(() => {
  if (window.NorifoxSavedItems) return;
  const node = document.getElementById('NfaConfig');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const key = 'norifox.saved-items.v1';
  let items = [];
  let persistent = true;
  const valid = (value) => Array.isArray(value) ? [...new Map(value.filter(item => item && /^[a-z0-9][a-z0-9-]*$/.test(item.handle) && /^\d+$/.test(String(item.id))).map(item => [String(item.id), { id: String(item.id), handle: item.handle, ...(item.variant && /^\d+$/.test(String(item.variant)) ? { variant: String(item.variant) } : {}) }])).values()].slice(0,100) : [];
  try { items = valid(JSON.parse(localStorage.getItem(key) || '[]')); } catch { persistent = false; }
  const saved = id => items.some(item => item.id === String(id));
  const sync = (root = document) => {
    const buttons = [...root.querySelectorAll('[data-nfa-save]')];
    if (root.matches?.('[data-nfa-save]')) buttons.push(root);
    buttons.forEach(button => {
      const state = saved(button.dataset.productId);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(state));
      const label = button.querySelector('[data-nfa-save-label]');
      const text = state ? config.text.saved : config.text.save;
      if (label && label.textContent !== text) label.textContent = text;
      const title = button.closest('.nfa-accessory, .nfa-wishlist-item')?.querySelector('h3')?.textContent?.trim() || button.dataset.handle.replaceAll('-', ' ');
      button.setAttribute('aria-label', `${text}: ${title}`);
    });
  };
  const update = () => {
    sync();
    document.dispatchEvent(new CustomEvent('nfa:wishlist-change'));
  };
  const persist = () => {
    try { localStorage.setItem(key, JSON.stringify(items)); persistent = true; } catch { persistent = false; }
    update();
  };
  const announce = (button, text) => {
    const scope = button.closest('.nfa-accessory, .nfa-product-save, .nfa-wishlist-item');
    const status = scope?.querySelector('[data-nfa-save-status]');
    if (status) status.textContent = text;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-nfa-save]');
    if (!button) return;
    const id = button.dataset.productId;
    const handle = button.dataset.handle;
    if (!/^\d+$/.test(id) || !/^[a-z0-9][a-z0-9-]*$/.test(handle)) return;
    if (saved(id)) {
      items = items.filter(item => item.id !== id);
      persist();
      announce(button, persistent ? config.text.removed : config.text.session_removed);
    } else {
      const form = button.closest('.nfp-info')?.querySelector('form');
      const variant = form?.dataset.nfaVariantChosen === 'true' ? form.querySelector('[name="id"]')?.value : null;
      items = valid([...items, { id, handle, ...(variant ? { variant } : {}) }]);
      persist();
      announce(button, persistent ? config.text.saved_message : config.text.session_saved);
    }
  });
  document.addEventListener('change', event => {
    const form = event.target.closest('form.nfp-form');
    if (form && (event.target.matches('[data-option-input], select[name="id"]') || event.target.closest('[data-option]'))) form.dataset.nfaVariantChosen = 'true';
  });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    try { items = valid(JSON.parse(event.newValue || '[]')); persistent = true; update(); } catch { persistent = false; }
  });
  window.addEventListener('pageshow', () => { try { items = valid(JSON.parse(localStorage.getItem(key) || '[]')); persistent = true; update(); } catch { persistent = false; } });
  const observer = new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(element => { if (element.nodeType === 1) sync(element); })));
  observer.observe(document.body, { childList: true, subtree: true });
  sync();
  const number = (cents, decimals, thousands, decimal) => {
    const parts = (Number(cents) / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  };
  const money = cents => {
    if (config.currency !== config.shopCurrency) return new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
    const formats = { amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'], amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','], amount_with_apostrophe_separator: [2, "'", '.'], amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', ','], amount_with_period_and_space_separator: [2, ' ', '.'] };
    const match = config.moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    const params = formats[match?.[1]];
    if (!params) return new Intl.NumberFormat(config.locale, { style: 'currency', currency: config.currency }).format(cents / 100);
    const value = config.moneyFormat.replace(match[0], number(cents, ...params));
    const clean = document.createElement('span'); clean.innerHTML = value; return clean.textContent;
  };
  const el = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text !== undefined) e.textContent = text; return e; };
  const productUrl = item => `${config.root}products/${encodeURIComponent(item.handle)}${item.variant ? `?variant=${encodeURIComponent(item.variant)}` : ''}`;
  class NfaWishlist extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      document.addEventListener('nfa:wishlist-change', () => this.render(), { signal: this.abort.signal });
      this.addEventListener('click', event => {
        const remove = event.target.closest('[data-nfa-remove]');
        if (remove) { items = items.filter(item => item.id !== remove.dataset.nfaRemove); persist(); this.querySelector('[data-wishlist-status]').textContent = persistent ? config.text.removed : config.text.session_removed; }
        if (event.target.closest('[data-nfa-retry]')) this.render();
      }, { signal: this.abort.signal });
      this.render();
    }
    disconnectedCallback() { this.abort?.abort(); this.fetchAbort?.abort(); }
    async render() {
      this.fetchAbort?.abort(); this.fetchAbort = new AbortController();
      const signal = this.fetchAbort.signal;
      const grid = this.querySelector('[data-wishlist-grid]');
      const empty = this.querySelector('[data-wishlist-empty]');
      const status = this.querySelector('[data-wishlist-status]');
      empty.hidden = items.length > 0; grid.hidden = !items.length;
      if (!items.length) { grid.replaceChildren(); status.textContent = persistent ? '' : config.text.storage_notice; return; }
      grid.setAttribute('aria-busy', 'true'); status.textContent = config.text.loading;
      const snapshot = [...items];
      const results = await Promise.all(snapshot.map(async item => {
        try {
          const response = await fetch(`${config.root}products/${encodeURIComponent(item.handle)}.js`, { signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) return { item, deleted: response.status === 404, failed: response.status !== 404 };
          const product = await response.json();
          if (String(product.id) !== item.id) return { item, deleted: true };
          return { item, product };
        } catch (error) { if (error.name === 'AbortError') return null; return { item, failed: true }; }
      }));
      if (signal.aborted || !this.isConnected) return;
      const fragment = document.createDocumentFragment();
      results.forEach(result => {
        if (!result) return;
        const { item, product, failed, deleted } = result;
        const card = el('li', 'nfa-wishlist-item');
        const href = productUrl(item);
        if (product) {
          const imageLink = el('a', 'nfa-well'); imageLink.href = href; imageLink.setAttribute('aria-label', product.title);
          const source = product.featured_image;
          if (source) {
            const url = new URL(source, location.origin);
            if (/^https?:$/.test(url.protocol)) { url.searchParams.set('width', '720'); const image = el('img'); image.src = url.href; image.alt = product.title; image.loading = 'lazy'; image.width = 720; image.height = 792; imageLink.append(image); }
          }
          if (!imageLink.childNodes.length) imageLink.append(el('span', 'nfa-no-image', config.text.no_image));
          card.append(imageLink);
          const caption = el('div', 'nfa-caption'); const title = el('h3'); const link = el('a', '', product.title); link.href = href; title.append(link); caption.append(title);
          const variant = item.variant ? product.variants.find(value => String(value.id) === item.variant) : null;
          if (variant && variant.title !== 'Default Title') caption.append(el('p', 'nfa-note', variant.title));
          caption.append(el('p', 'nfa-price', `${!variant && product.price_varies ? config.text.from + ' ' : ''}${money(variant?.price ?? product.price)}`));
          if (!(variant?.available ?? product.available)) caption.append(el('p', 'nfa-note', config.text.unavailable));
          const view = el('a', 'nfa-button', config.text.view_product); view.href = href; caption.append(view); card.append(caption);
        } else {
          card.append(el('h3', '', deleted ? config.text.deleted : config.text.load_failed));
          if (failed) { const view = el('a', 'nfa-link', config.text.open_product); view.href = href; card.append(view); const retry = el('button', 'nfa-remove', config.text.retry); retry.type = 'button'; retry.dataset.nfaRetry = ''; card.append(retry); }
        }
        const remove = el('button', 'nfa-remove', config.text.remove); remove.type = 'button'; remove.dataset.nfaRemove = item.id; remove.setAttribute('aria-label', `${config.text.remove}: ${product?.title || item.handle.replaceAll('-', ' ')}`); card.append(remove);
        fragment.append(card);
      });
      grid.replaceChildren(fragment); grid.removeAttribute('aria-busy'); status.textContent = persistent ? '' : config.text.storage_notice;
    }
  }
  class NfaLook extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.loaded) return;
      this.loaded = true; this.abort = new AbortController();
      fetch(this.dataset.url, { signal: this.abort.signal, credentials: 'same-origin' }).then(response => { if (!response.ok) throw new Error('recommendations'); return response.text(); }).then(html => {
        if (!this.isConnected) return;
        const incoming = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-nfa-look-content]');
        if (incoming && incoming.querySelector('.nfa-accessory')) this.querySelector('[data-nfa-look-content]').replaceWith(incoming);
      }).catch(() => {});
    }
    disconnectedCallback() { this.abort?.abort(); this.loaded = false; }
  }
  class NfaSubmission extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const form = this.querySelector('form');
      if (!form) return;
      const photos = form.querySelector('[data-nfa-photos]');
      const validate = () => {
        const urls = photos.value.split(/\r?\n/).map(value => value.trim()).filter(Boolean);
        const correct = urls.length > 0 && urls.length <= 5 && urls.every(value => { try { return /^https?:$/.test(new URL(value).protocol); } catch { return false; } });
        photos.setCustomValidity(correct ? '' : config.text.invalid_photos);
      };
      photos.addEventListener('input', validate, { signal: this.abort.signal });
      form.addEventListener('submit', event => {
        validate();
        if (!form.reportValidity() || this.submitting) { event.preventDefault(); return; }
        this.submitting = true; form.setAttribute('aria-busy', 'true');
        form.querySelector('[data-submit-label]').textContent = config.text.submitting;
      }, { signal: this.abort.signal });
      window.addEventListener('pageshow', () => { this.submitting = false; form.removeAttribute('aria-busy'); form.querySelector('[data-submit-label]').textContent = config.text.submit; }, { signal: this.abort.signal });
      this.querySelector('[data-form-result]')?.focus();
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  class NfaDraftGuides extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const show = () => {
        const guide = new URL(location.href).searchParams.get('guide');
        const article = guide ? this.querySelector(`[data-draft-article="${CSS.escape(guide)}"]`) : null;
        this.querySelector('[data-draft-hub]').hidden = !!article;
        this.querySelectorAll('[data-draft-article]').forEach(element => { element.hidden = element !== article; });
        const category = new URL(location.href).searchParams.get('category') || 'all';
        this.querySelectorAll('[data-draft-category]').forEach(element => { element.hidden = category !== 'all' && element.dataset.draftCategory !== category; });
        this.querySelectorAll('[data-guide-filter]').forEach(link => { if (link.dataset.guideFilter === category) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current'); });
      };
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-draft-link], [data-guide-filter]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); history.pushState(null, '', link.href); show(); this.querySelector(articleSelector()).focus();
      }, { signal: this.abort.signal });
      const articleSelector = () => this.querySelector('[data-draft-hub]').hidden ? '[data-draft-article]:not([hidden]) h1' : '[data-draft-hub] h1';
      window.addEventListener('popstate', show, { signal: this.abort.signal }); show();
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  for (const [name, component] of [['nfa-wishlist', NfaWishlist], ['nfa-look', NfaLook], ['nfa-submission', NfaSubmission], ['nfa-draft-guides', NfaDraftGuides]]) if (!customElements.get(name)) customElements.define(name, component);
  window.NorifoxSavedItems = { get items() { return items.map(item => ({...item})); }, get persistent() { return persistent; } };
})();
